import { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { toast } from 'react-toastify';
import _ from 'lodash';
import 'react-toastify/dist/ReactToastify.css';

import CustomSwitch from '../../extras/CustomSwitch';
import {
  getGroupsSessionVisibility,
  updateGroup,
} from './../../services/apiService';

class SessionVisibility extends Component {
  constructor(props) {
    super(props);

    this.state = {
      groups: [],
      selectedGroupId: null,
      selectedGroup: null,
      selectedTheme: null,
      subTopicDescToggle: {},
      isLoading: true,
      isUpdating: false,
    };
  }

  componentDidMount = async () => {
    const groups = await getGroupsSessionVisibility();
    this.setState({
      groups,
      selectedGroupId: groups[0].id,
      selectedGroup: groups[0],
      isLoading: false,
    });
  };

  updateSessionVisibility = async () => {
    this.setState({ isUpdating: true });
    try {
      const groupData = this.state.selectedGroup;
      await updateGroup(groupData);
      toast.dark(`Session Visibility For ${groupData.name} group updated`, {
        position: 'bottom-right',
        autoClose: 2200,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });
    } catch (err) {
      console.err(err);
      toast.error('Failed to update, please try again later!', {
        position: 'bottom-right',
        autoClose: 2200,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
    this.setState({ isUpdating: false });
  };

  isThemeLocked = (themeId) => {
    const sessionVisibility = this.state.selectedGroup.sessionVisibility || {};
    for (const id in sessionVisibility) {
      if (themeId === id) return false;
    }
    return true;
  };

  isSubTopicHidden = (subTopicId) => {
    const sessionVisibility = this.state.selectedGroup.sessionVisibility || {};
    for (const themeId in sessionVisibility) {
      for (const topicId in sessionVisibility[themeId]) {
        for (const id of sessionVisibility[themeId][topicId]) {
          if (subTopicId === id) return false;
        }
      }
    }
    return true;
  };

  changeThemeLockStatus = (themeId) => {
    const sessionVisibility = this.state.selectedGroup.sessionVisibility || {};
    if (this.isThemeLocked(themeId)) sessionVisibility[themeId] = {};
    else delete sessionVisibility[themeId];
    this.setState({
      selectedGroup: {
        ...this.state.selectedGroup,
        sessionVisibility,
      },
    });
  };

  changeSubTopicHiddenStatus = (subTopicId, topicId, themeId) => {
    const sessionVisibility = this.state.selectedGroup.sessionVisibility || {};
    if (_.isEmpty(sessionVisibility[themeId])) sessionVisibility[themeId] = {};
    if (_.isEmpty(sessionVisibility[themeId][topicId]))
      sessionVisibility[themeId][topicId] = [];
    if (this.isSubTopicHidden(subTopicId))
      sessionVisibility[themeId][topicId].push(subTopicId);
    else
      _.remove(sessionVisibility[themeId][topicId], (id) => id === subTopicId);
    this.setState({
      selectedGroup: {
        ...this.state.selectedGroup,
        sessionVisibility,
      },
    });
  };

  handleGroupSelection = ({ target }) =>
    this.setState({
      selectedGroupId: target.value,
      selectedGroup: this.state.groups.find(({ id }) => target.value === id),
    });

  handleSubTopicDescriptionToggle = (subTopicId) =>
    this.setState({
      subTopicDescToggle: {
        ...this.state.subTopicDescToggle,
        [subTopicId]: !this.state.subTopicDescToggle[subTopicId],
      },
    });

  render() {
    return (
      <div>
        <h1 className='user-heading text-3xl font-semibold'>
          Session Visibility
        </h1>
        {!this.state.isLoading ? (
          <div>
            {/* group selection dropdown */}
            <div className='mt-8 bg-white rounded-lg p-4 flex items-center'>
              <FormControl
                variant='outlined'
                size='small'
                className='max-w-xs'
                fullWidth
              >
                <InputLabel>Select Group or Cohort</InputLabel>
                <Select
                  onChange={this.handleGroupSelection}
                  value={this.state.selectedGroupId}
                  label='Select Group or Cohort'
                >
                  {this.state.groups.map((group) => (
                    <MenuItem value={group.id} key={group.id}>
                      {group.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <span className='ml-8 opacity-60'>
                Changes will be applied to selected group only.
              </span>
              <Link
                to='/new-group'
                className='text-blue-c1 underline font-underline ml-2'
              >
                Create New Group
              </Link>
            </div>

            <div className='grid grid-cols-2 gap-4 mt-4'>
              {/* theme list */}
              <div className='flex flex-col gap-4'>
                {this.props.themes.map((theme) => (
                  <div
                    onClick={() => {
                      this.setState({ selectedTheme: theme });
                    }}
                    className={`cursor-pointer rounded-lg bg-white px-6 py-4 items-center justify-between flex ${
                      theme.id === this.state.selectedTheme?.id
                        ? 'border-2 border-green-c2'
                        : ''
                    }`}
                    key={theme.id}
                  >
                    <div>
                      <h1 className='text-lg font-medium opacity-80'>
                        {theme.name}
                      </h1>
                      <span className='text-sm opacity-60'>
                        Theme ID: {theme.id}
                      </span>
                    </div>
                    <div>
                      <CustomSwitch
                        checked={this.isThemeLocked(theme.id)}
                        onChange={({ target }) => {
                          this.changeThemeLockStatus(theme.id);
                        }}
                      />
                      <span className='inline-block w-20 ml-2 opacity-60'>
                        {this.isThemeLocked(theme.id) ? 'locked' : 'unlocked'}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              {/* subtopic list of selected theme */}
              {this.state.selectedTheme ? (
                <div className='bg-white rounded-lg px-6 py-4'>
                  <h4 className='text-xl font-medium opacity-80'>
                    {this.state.selectedTheme.name}
                  </h4>
                  {this.state.selectedTheme.topics.map((topic) => (
                    <div className='py-4' key={topic.id}>
                      <h6 className='text-lg text-green-c1 font-medium opacity-90'>
                        {topic.name}
                      </h6>
                      {topic.subTopics.map((subTopic) => (
                        <div className='p-2' key={subTopic.id}>
                          <div className='flex items-center justify-between gap-8'>
                            <span
                              onClick={() =>
                                this.handleSubTopicDescriptionToggle(
                                  subTopic.id
                                )
                              }
                              className='cursor-pointer flex items-center justify-between flex-grow'
                            >
                              <span className='font-medium opacity-60'>
                                {subTopic.name}
                              </span>
                              {this.state.subTopicDescToggle[subTopic.id] ? (
                                <ArrowDropUp className='opacity-80' />
                              ) : (
                                <ArrowDropDown className='opacity-60' />
                              )}
                            </span>

                            <span>
                              <CustomSwitch
                                checked={this.isSubTopicHidden(subTopic.id)}
                                onChange={({ target }) =>
                                  this.changeSubTopicHiddenStatus(
                                    subTopic.id,
                                    topic.id,
                                    this.state.selectedTheme.id
                                  )
                                }
                              />
                              <span className='inline-block w-12 ml-2 opacity-60'>
                                {this.isSubTopicHidden(subTopic.id)
                                  ? 'hide'
                                  : 'unhide'}
                              </span>
                            </span>
                          </div>
                          {this.state.subTopicDescToggle[subTopic.id] && (
                            <p className='text-sm opacity-60 mt-1'>
                              <span className='text-xs opacity-50 block'>
                                ID: {subTopic.id}
                              </span>
                              {subTopic.description}
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ) : (
                <div className='bg-white rounded-lg flex'>
                  <span className='m-auto text-lg font-medium opacity-40'>
                    Select Theme from Left
                  </span>
                </div>
              )}
            </div>
            <button
              onClick={this.updateSessionVisibility}
              disabled={this.state.isUpdating}
              className='bg-blue-c1 text-white rounded-md px-6 py-2 mt-4'
            >
              {this.state.isUpdating ? (
                <CircularProgress
                  color='inherit'
                  size='1.5rem'
                  className='mx-11 -my-1.5'
                />
              ) : (
                <span>Save Changes</span>
              )}
            </button>
          </div>
        ) : (
          <div className='bg-white rounded-lg py-32 mt-8 flex items-center justify-center text-blue-c1'>
            <CircularProgress color='inherit' size='4rem' />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  themes: state.themeReducer.themes,
});

export default connect(mapStateToProps, null)(SessionVisibility);
